<template>
  <div class="h-full p-2 py-4 flex flex-col justify-center items-center bg-blue-DEFAULT">
    <h3 class="text-gray-light">{{ title }}</h3>
    <img class="h-20 w-20" :src="require(`@/assets/images/${state}.png`)" alt="">
    <div class="flex justify-between">
      <p class="mr-4 text-gray-light">
        <span class="mr-1">{{temperature.min}}</span>
        <span>°{{currentTemperatureUnit}}</span>
      </p>
      <p class="text-gray-DEFAULT">
        <span class="mr-1">{{temperature.max}}</span>
        <span>°{{currentTemperatureUnit}}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    currentTemperatureUnit: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    state:{
      type: String,
      required: true,
    },
    temperature: {
      type: Object,
      require: true
    }
  }
}
</script>
